import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { Typography, Stack, Box } from "@mui/material";
import { PieChart } from '@mui/x-charts/PieChart';
import { BarChart } from "@mui/x-charts/BarChart";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import DisplayGraphics from "./DisplayGraphics";
const helpers = require('../../helpers/helpers')
const admin_service = require("../../helpers/admin_service");


function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


const UCGraphics = (props) => {
    const [contador] = useState({});
    const [report, setReport] = useState([]);
    const [value, setValue] = React.useState(0);
    const [conteo, setConteo] = useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    useEffect(() => {
        const jwt = JSON.parse(Cookies.get(process.env.REACT_APP_COOKIE_KEY));
        admin_service
            .getDataAuth(
                "/uc/report",
                jwt.TokenType,
                jwt.accessToken
            )
            .then((datos_reporte) => {
                setReport(helpers.classifyByField(datos_reporte.data.salida, 'segment'))
                setConteo(datos_reporte.data.conteo)
            })
            .catch((err) => {
                console.log(err);
            });
    }, [contador]);
    return (
        <Stack spacing={3} mt={5}>
            <Typography variant='h3' textAlign='center'>Respuestas a Formulario Universidad Corporativa Potenciales Estudiantes</Typography>
            <Typography variant='h6' textAlign='center'>Conteo de respuetas: {conteo}</Typography>

            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label="Datos Demográficos" {...a11yProps(0)} />
                        <Tab label="Acerca de un posgrado" {...a11yProps(1)} />
                        <Tab label="Importancia de un posgrado" {...a11yProps(2)} />
                        <Tab label="Consideración sobre un posgrado" {...a11yProps(3)} />
                        <Tab label="Preferencias sobre un posgrado" {...a11yProps(4)} />

                    </Tabs>
                </Box>
                <CustomTabPanel value={value} index={0}>
                    {report.length > 0 && <DisplayGraphics report={report[0]} title="Datos Demográficos" />}
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                    {report.length > 0 && <DisplayGraphics report={report[1]} title="Acerca de un posgrado" />}
                </CustomTabPanel>
                <CustomTabPanel value={value} index={2}>
                    {report.length > 0 && <DisplayGraphics report={report[2]} title="Importancia de un posgrado" />}
                </CustomTabPanel>
                <CustomTabPanel value={value} index={3}>
                    {report.length > 0 && <DisplayGraphics report={report[3]} title="Consideración sobre un posgrado" />}
                </CustomTabPanel>
                <CustomTabPanel value={value} index={4}>
                    {report.length > 0 && <DisplayGraphics report={report[4]} title="Preferencias sobre un posgrado" />}
                </CustomTabPanel>
            </Box>
        </Stack>
    );
};

export default UCGraphics;
